import { ArticlePageContextValue } from "contexts/new/ArticlePageContext";
import { UserContextValue } from "contexts/new/UserContext";
import { RoutingContextValue, useRoutingContext } from "contexts/new/RoutingContext";
import { trackEvent } from "services/frontend/Segment";
import { useEffect, useState } from "react";

export function useRecordPaywallViewed(args: {
  paywalled: boolean;
  articlePageContext: ArticlePageContextValue;
  routingContext: RoutingContextValue;
  userContext: UserContextValue;
}) {
  const [eventFired, setEventFired] = useState(false);

  useEffect(() => {
    if (args.paywalled && !eventFired) {
      trackEvent("Paywall Viewed", {
        author: args.articlePageContext.authorName,
        category: args.articlePageContext.categoriesListForAnalytics,
        article_title: args.articlePageContext.articleTitle,
        article_id: args.articlePageContext.articleId,
        previous_page: args.routingContext.referrer,
        previous_page_type: args.routingContext.referrer_type,
        logged_in: args.userContext.loggedIn,
        subscriber: args.userContext.userIsSubscriber,
      });
      setEventFired(true);
    }
  }, [
    args.paywalled,
    args.articlePageContext,
    args.routingContext,
    args.userContext,
    eventFired,
  ]);
}
